import { Component, OnInit, OnDestroy, ViewChildren, QueryList, ViewChild, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { RichTextComponent } from '../../../../core/shared/richtext/richtext.component';
import { Employee } from '../../employee.model';
import { ModalComponent } from '../../../../core/shared/modal/modal.component';

@Component({
  selector: 'app-employee-signature-modal',
  templateUrl: './employee-signature-modal.component.html'
})
export class EmployeeSignatureModalComponent implements OnInit, OnDestroy {
  @Output() onClose = new EventEmitter<any>();

  private employee: Employee;
  private subscription: Subscription;
  private signatureView: RichTextComponent = null;

  @ViewChild(ModalComponent) public modal: ModalComponent;
  @ViewChildren(RichTextComponent) signatureViews: QueryList<RichTextComponent>;

  constructor() { }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public setModel(employee: Employee) {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.employee = employee;
    this.modal.openWithCustomSize({ 'maxwidth': '1000px' });
    this.getSignature();
  }

  public closeModal() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.modal.close();
    this.onClose.emit();
  }

  public saveSignature() {
    let signature = this.signatureView.getHtml();
    if (this.signatureView.isEmpty(signature)) {
      this.employee.emailSignature = '';
    } else {
      this.employee.emailSignature = signature;
    }

    this.closeModal();
  }

  private getSignature() {
    if (!this.signatureViews) {
      return;
    }
    this.subscription = this.signatureViews.changes.subscribe((nv: QueryList<RichTextComponent>) => {
      if (this.signatureView === null) {
        this.signatureView = nv.first;
      }

      if (this.signatureView && this.employee.emailSignature && this.employee.emailSignature !== '') {
        this.signatureView.setHtml(this.employee.emailSignature);
      } else {
        this.signatureView.setHtml('');
      }
    });
  }

}
